'use client';

import dynamic from "next/dynamic";

const AboveFoldEffects = dynamic(() => import("./AboveFoldEffects"), {
  ssr: false,
});

const CollapsibleStudioBanner = dynamic(
  () => import("./CollapsibleStudioBanner"),
  { ssr: false },
);

export default function HomeEnhancements() {
  return (
    <>
      <CollapsibleStudioBanner />
      <AboveFoldEffects />
    </>
  );
}
